@if (showDetailsBox()) {
  <section class="total-estimated-costs">
    <section class="costs-and-coverages">
      <!-- OVER-65 DRUGS -->
      @if (hasSeniorDrugs) {
        <app-senior-drug-coverage [plan]="plan" [addMedicationsUrl]="addMedicationsUrl"></app-senior-drug-coverage>
      }
      <!-- UNDER-65 DRUGS -->
      @if (hasIndividualDrugs) {
        <app-individual-drug-coverage [plan]="plan"></app-individual-drug-coverage>
      }
      <!-- Shared Provider Logic -->
      @if (showProviderCoverage) {
        <div>
          <div class="coverage">
            @if (providerPlanInfo.count) {
              <span class="material-symbols-outlined covered-or-in-network">check_circle_outline</span>
            }
            @if (providerPlanInfo.count) {
              <span class="coverage-text">
                Provider Coverage
                <span class="next-line-if-mobile">({{ providerPlanInfo.count }} covered)</span>
              </span>
            }
            @if (!providerPlanInfo.count) {
              <span class="material-symbols-outlined not-covered-out-of-network">highlight_off</span>
            }
            @if (!providerPlanInfo.count) {
              <span class="coverage-text">No Provider Coverage</span>
            }
          </div>
          <button mat-button color="primary" (click)="showMedicalDetails()">
            Show Provider Details
          </button>
        </div>
      }
    </section>
  </section>
}